<div class="min-h-screen bg-gradient-login relative overflow-hidden">
  <img
    src="/assets/backgrounds/login-background-circle.svg"
    alt="Login Background Circle"
    class="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 z-0"
  />
  <img
    src="/assets/backgrounds/login-background-circle.svg"
    alt="Login Background Circle"
    class="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 z-0"
  />
  <div class="relative z-10 flex flex-col items-center justify-center min-h-screen gap-8 px-4">
    <img src="/assets/imgs/afp-capital-white.png" alt="AFP Capital" class="max-w-44 max-h-[58px]" />
    <div class="bg-white rounded-lg p-4 max-w-[366px] shadow-lg">
      <app-credentials-step [isLoading]="isLoading()" (submitForm)="onFormSubmit($event)" />
    </div>
  </div>
</div>
